import browser from '../components/utils/browser'

const isIOS = browser.getOSName() === 'iOS'

export default (text, unit) => `${text}${isIOS ? `／ ${unit}` : `（${unit}）`}`
